// import { loadResources } from './resources';

(function ($, document) {
  const $document = $(document);
  const loadMoreButtonClass = 'resources-load-more--btn';

  let filterType = 'all';
  let filterTopic = 'all';

  const resourceItemsFilterURL = function () {
    const winloc = window.location;
    const url = `${winloc.protocol}//${winloc.host}${winloc.pathname}`;

    let urlParams = '';

    if (filterType !== '' && filterType !== 'all') {
      urlParams = `/${filterType}`;
    }

    if (filterTopic !== '' && filterTopic !== 'all') {
      urlParams = `${urlParams}/${filterTopic}`;
    }

    if (urlParams) {
      const newurl = `${url}#${urlParams}`;

      window.history.pushState({ path: newurl }, '', newurl);
    } else {
      window.history.pushState({ path: url }, '', url);
    }
  };

  const resourceItemsPageCheckURL = function () {
    const array = window.location.href.split('/');

    $('.section-resources-lobby__filter a[data-filter-type="type"]').each(function () {
      const val = $(this).attr('data-filter-slug');

      if (array.includes(val)) {
        filterType = val;

        $(this).addClass('active');
        resourceItemsFilterURL();
      }
    });

    $('.section-resources-lobby__filter a[data-filter-type="topic"]').each(function () {
      const val = $(this).attr('data-filter-slug');

      if (array.includes(val)) {
        filterTopic = val;

        $(this).addClass('active');
        resourceItemsFilterURL();
      }
    });

    onChangeFilterCallback();
  };

  const onChangeFilterCallback = function () {
    const $parent = $(document).find('.section-resources-lobby__items');

    if ($parent.length > 0) {
      $parent.find('.resource-item').remove();
      $parent.find(`.${loadMoreButtonClass}`).show();
      $parent.find(`.${loadMoreButtonClass}`).trigger('resources:loadMore');
    }
  };

  $document.ready(() => {
    if ($('.section-resources-lobby__items').length > 0) {
      if(window.location.hash) {
        resourceItemsPageCheckURL();
      }

      $(window).on('popstate', function () {
        if(window.location.hash) {
          resourceItemsPageCheckURL();
        } 
      });

      $('.section-resources-lobby__filter a[data-filter-type="type"]').on('click', function (e) {
        e.preventDefault();
        const value = $(this).attr('data-filter-slug');
        
        $('.section-resources-lobby__filter a[data-filter-type="type"].active').removeClass('active');
        $(this).addClass('active');

        if (value) {
          filterType = value;
        } else {
          filterType = 'all';
        }

        resourceItemsFilterURL();
        onChangeFilterCallback();
      });

      $('.section-resources-lobby__filter a[data-filter-type="topic"]').on('click', function (e) {
        e.preventDefault();
        const value = $(this).attr('data-filter-slug');
        
        $('.section-resources-lobby__filter a[data-filter-type="topic"].active').removeClass('active');
        $(this).addClass('active');

        if (value) {
          filterTopic = value;
        } else {
          filterTopic = 'all';
        }

        resourceItemsFilterURL();
        onChangeFilterCallback();
      });
    }
  });
})(jQuery, document);



// WEBPACK FOOTER //
// ./scripts/routes/resourcesListing.js